import { UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Col, Descriptions, Image, Modal, Rate, Row, Space } from 'antd'
import moment from 'moment'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import styled from 'styled-components'
import { AuthContext } from '../../../contexts/Auth'
import {
  getReservationDetail,
  manageRequestReservation,
  RequestAction,
} from '../../../services/Host'
import ReservationStatus from '../ReservationStatus'
import ActionModal from './ActionModal'
import Description from './Description'
import RejectModal from './RejectModal'
const StyledButton = styled(Button)`
  border-radius: 18rem;
`

interface MatchParams {
  reservationNo: string
}

interface Props extends RouteComponentProps<MatchParams> {
  prop?: any
}

export interface IReservationDetail {
  reservationNo: number
  reservationState: string
  renterName: string
  renterScore: number
  vehicleLicense: string
  vehicleModel: string
  vehicleScore: number
  vehicleReviews: number
  vehiclePicture: string
  reserveStartTime: string
  reserveStopTime: string
  hostStationName: string
  hostStationLink: string
  dstStationName: string
  dstStationLink: string
  estimatePrice: number
  note: string
}

function error(title: string, content: string) {
  Modal.error({
    title,
    content,
  })
}

function info(title: string, content: string) {
  Modal.info({
    title,
    content,
  })
}

class HostReservation extends React.Component<Props> {
  static contextType = AuthContext
  state = {
    reservationNo: 0,
    reservationDetail: {
      reservationNo: 0,
      reservationState: '',
      renterName: '',
      renterScore: 0,
      vehicleLicense: '',
      vehicleModel: '',
      vehicleScore: 0,
      vehicleReviews: 0,
      vehiclePicture: '',
      reserveStartTime: '',
      reserveStopTime: '',
      hostStationName: '',
      hostStationLink: '',
      dstStationName: '',
      dstStationLink: '',
      estimatePrice: 0,
      note: '',
    },
    btnAcceptLoading: false,
    btnAcceptDisabled: true,
    btnRejectDisabled: true,
    showAcceptModal: false,
    showRejectModal: false,
  }

  componentDidMount() {
    const reservationNo = this.props?.match?.params?.reservationNo
    this.setState({ reservationNo })
    this.getReservation(parseInt(reservationNo))
  }

  acceptReservation = () => {
    this.setState({ btnAcceptLoading: true, btnRejectDisabled: true })
    manageRequestReservation(
      this.context,
      RequestAction.accept,
      this.state.reservationDetail.reservationNo,
      '',
    )
      .then((_result) => {
        this.setState({
          showAcceptModal: true,
          btnAcceptLoading: false,
          btnAcceptDisabled: true,
          btnRejectDisabled: true,
        })
        this.getReservation(this.state.reservationNo)
      })
      .catch((errorMessage) => {
        const { message } = errorMessage
        this.setState({
          btnAcceptLoading: false,
          btnAcceptDisabled: false,
          btnRejectDisabled: false,
        })
        error(`Can't accept this reservation`, message)
      })
  }

  showRejectModal = () => {
    this.setState({ showRejectModal: true })
  }

  rejectReservation = async (reason: string) => {
    return manageRequestReservation(
      this.context,
      RequestAction.reject,
      this.state.reservationDetail.reservationNo,
      reason,
    )
      .then((result) => {
        console.log(result)
        info(`Success`, 'Reject this reservation sucessfully.')
        this.setState({
          btnAcceptLoading: false,
          btnAcceptDisabled: true,
          btnRejectDisabled: true,
        })
        return true
      })
      .catch((errorResponse) => {
        const { message } = errorResponse
        error(`Can't reject this reservation`, message)
        this.setState({
          btnAcceptLoading: false,
          btnAcceptDisabled: false,
          btnRejectDisabled: false,
        })
      })
  }

  getReservation(reservationNo: number) {
    const generateMapUrl = (latitude: number, longitude: number): string => {
      return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
    }
    getReservationDetail(this.context, reservationNo).then((result) => {
      const {
        vehicle_score,
        vehicle_reviews,
        dst_stationlatitude,
        dst_stationlongitude,
        dst_stationname,
        estimatedprice,
        host_stationlatitude,
        host_stationlongitude,
        host_stationname,
        licensenumber,
        picture_url,
        remark,
        renter_name,
        requestNote,
        reservationno,
        reservationstate,
        reservestarttime,
        reservestoptime,
        vehiclemodel,
      } = result
      this.setState({
        reservationDetail: {
          reservationNo: reservationno,
          reservationState: reservationstate,
          renterName: renter_name,
          renterScore: null,
          vehicleLicense: licensenumber,
          vehicleModel: vehiclemodel,
          vehicleScore: vehicle_score,
          vehicleReviews: vehicle_reviews,
          vehiclePicture: picture_url,
          reserveStartTime: moment(reservestarttime).format('ddd D MMM, YYYY HH:mm'),
          reserveStopTime: moment(reservestoptime).format('ddd D MMM, YYYY HH:mm'),
          hostStationName: host_stationname,
          hostStationLink: generateMapUrl(host_stationlatitude, host_stationlongitude),
          dstStationName: dst_stationname,
          dstStationLink: generateMapUrl(dst_stationlatitude, dst_stationlongitude),
          estimatePrice: estimatedprice,
          note: requestNote || remark,
        },
        btnAcceptDisabled: false,
        btnRejectDisabled: false,
      })
    })
  }

  render() {
    const MapLink = (link: string) => (
      <a href={link} target="_blank" style={{ textDecorationLine: 'underline' }}>
        View Map
      </a>
    )

    const {
      reservationNo,
      reservationState,
      renterName,
      renterScore,
      vehicleLicense,
      vehicleModel,
      vehicleReviews,
      vehicleScore,
      reserveStartTime,
      reserveStopTime,
      hostStationName,
      hostStationLink,
      dstStationName,
      dstStationLink,
      estimatePrice,
      note,
    } = this.state?.reservationDetail
    return (
      <div style={{ height: '100%' }}>
        <Row justify="center">
          <Col flex="0 1 500px">
            {this.state.showAcceptModal && (
              <ActionModal
                isModalVisible={this.state.showAcceptModal}
                reservationDetail={this.state.reservationDetail}
              />
            )}
            {this.state.showRejectModal && (
              <RejectModal
                isModalVisible={this.state.showRejectModal}
                onReject={this.rejectReservation}
              />
            )}

            <Row
              className="pad-content"
              style={{
                backgroundColor: '#0046A0',
                position: 'sticky',
                top: '0',
                zIndex: 99,
                color: 'white',
              }}
            >
              <Col span={24}>
                <Row justify="center">
                  <Col style={{ textAlign: 'center', fontSize: '1rem' }}>
                    #{reservationNo} <ReservationStatus reservationState={reservationState} />
                  </Col>
                </Row>
                <Row>
                  <Space>
                    <Col>
                      <Avatar size={80} icon={<UserOutlined />} />
                    </Col>
                    <Col>
                      <div style={{ color: 'white', fontSize: '1rem' }}>{renterName}</div>
                      <div>Score: {renterScore ? renterScore : ' - '}</div>
                    </Col>
                  </Space>
                </Row>
              </Col>
            </Row>
            <Row className="pad-content">
              <Col>
                <h3>Car Detail</h3>
                <Row>
                  <Space size="large">
                    <Col>
                      <Image
                        height={100}
                        src={this.state.reservationDetail.vehiclePicture}
                        fallback="data:image/png;base64,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"
                      />
                    </Col>
                    <Col>
                      <h3>{vehicleLicense}</h3>
                      <h3>{vehicleModel}</h3>
                      {vehicleScore}{' '}
                      <Rate
                        disabled
                        allowHalf
                        defaultValue={vehicleScore}
                        style={{ color: '#0046A0' }}
                      />{' '}
                      <div style={{ display: 'inline-block' }}> {vehicleReviews} Reviews</div>
                    </Col>
                  </Space>
                </Row>
              </Col>
            </Row>
            <Row className="pad-content">
              <Col style={{ width: '100%' }}>
                <Description title="Reservation Date" bordered>
                  <Descriptions.Item label="Start">
                    <h3>{reserveStartTime}</h3>
                  </Descriptions.Item>
                  <Descriptions.Item label="End">
                    <h3>{reserveStopTime}</h3>
                  </Descriptions.Item>
                </Description>
              </Col>
            </Row>
            <Row className="pad-content">
              <Col span={24}>
                <Description title="Pick up Location" extra={MapLink(dstStationLink)}>
                  <Descriptions.Item>{hostStationName}</Descriptions.Item>
                </Description>
              </Col>
            </Row>
            <Row className="pad-content">
              <Col span={24}>
                <Description title="Drop off Location" extra={MapLink(dstStationLink)}>
                  <Descriptions.Item>{dstStationName}</Descriptions.Item>
                </Description>
              </Col>
            </Row>
            <Row className="pad-content">
              <Col>
                <Description title="Special Request">
                  <Descriptions.Item>-</Descriptions.Item>
                </Description>
              </Col>
            </Row>
            <Row className="pad-content">
              <Col>
                <Description title="Note">
                  <Descriptions.Item>{note}</Descriptions.Item>
                </Description>
              </Col>
            </Row>
            <Row
              style={{
                position: 'sticky',
                bottom: '0',
                zIndex: 99,
                backgroundColor: 'white',
                borderTop: '1px solid black',
                padding: '1rem',
              }}
              justify="space-around"
              align="middle"
            >
              <Col style={{ width: '100%' }}>
                <Row justify="space-around" align="middle">
                  <Col>
                    <div style={{ fontSize: '0.8rem' }}>Estimate Price</div>
                    <div style={{ fontSize: '1.2rem' }}>฿ {estimatePrice}</div>
                    <p></p>
                  </Col>
                  <Col offset={6} style={{ textAlign: 'right' }}>
                    <Space>
                      <StyledButton
                        type="primary"
                        loading={this.state.btnAcceptLoading}
                        onClick={this.acceptReservation}
                        disabled={
                          this.state.btnAcceptDisabled ||
                          this.state.reservationDetail.reservationState !== 'REQUEST'
                        }
                      >
                        Accept
                      </StyledButton>
                      <StyledButton
                        type="primary"
                        danger
                        disabled={
                          this.state.btnRejectDisabled ||
                          this.state.reservationDetail.reservationState !== 'REQUEST'
                        }
                        onClick={() => this.showRejectModal()}
                      >
                        Decline
                      </StyledButton>
                    </Space>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

export default HostReservation
